import { lazy } from "react";

export const FeaturedJobs = lazy(() => import("./FeaturedJobs"));
export const CompanyProfile = lazy(() => import("./CompanyProfile"));
export const JobDetails = lazy(() => import("./JobDetails"));
export const JobListing = lazy(() => import("./JobListing"));
